import React, { useState, useEffect } from "react";
import classes from "../../module.css/NewBooking.module.css";
import Heading from "../../tailwindUI/Heading";
import Input from "../../tailwindUI/Input";
import Button from "../../tailwindUI/Button";
import ErrorMessage from "../../tailwindUI/ErrorMessage";
import SuccessMessage from "../../tailwindUI/SuccessMessage";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../../tailwindUI/Navbar";

const todayDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = yyyy + "-" + mm + "-" + dd;
  return formattedToday;
};

const StmInterdealerUpdateBooking = () => {
  const location = useLocation();
  const carDetail = location.state?.carDetail || {};

  // Initialize state with carDetail values
  const [wingsData, setWingsData] = useState({});
  const [fName, setFname] = useState(carDetail.customer_name || "");
  const [lName, setLname] = useState(carDetail.LastName || "");
  const [mobile, setMobile] = useState(carDetail.customer_mobile || "");
  const [bookingDate, setBookingDate] = useState(carDetail.booking_date || "");
  const [committedDate, setCommittedDate] = useState(
    carDetail.CommittedDeliveryDate || ""
  );
  const [wings, setWings] = useState("");
  const [wingsLoading, setWingsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [wingserrorMessage, setWingsErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(true);
  const [exchange, setExchange] = useState(carDetail.exchange || "No");
  const [remark, setRemark] = useState(carDetail.Remark || "");
  const [carModel, setCarModel] = useState(carDetail.car_model || "");
  const [carVariant, setCarVariant] = useState(carDetail.car_variant || "");
  const [carColour, setCarColour] = useState(carDetail.car_colour || "");
  const [yom, setYom] = useState(carDetail.yom || "");
  const [filteredList, setFilteredList] = useState({
    Model: [],
    Variant: [],
    Colour: [],
  });

  const UserToken = localStorage.getItem("UserToken");
  const navigate = useNavigate();

  console.log(carDetail, "888888888888888888888888");

  const notificationMethods = [
    { id: "Yes", title: "Yes" },
    { id: "No", title: "No" },
  ];

  const onlyNumeric = (e, setState) => {
    var reg = /^-?\d+$/;
    reg.test(e.target.value) || e.target.value === ""
      ? setState(e.target.value)
      : console.log("");
  };

  const validYear = (date) => {
    return date.split("-")[0];
  };

  const validation = () => {
    const commitedDate = new Date(committedDate);
    const bookingdate = new Date(bookingDate);
    const regPhone = /^[6789][0-9]{9}$/;
    const validYomValues = ["2023", "2024", "2025", "2026"];
    let isValid = true;
    let error = {};

    if (!fName.trim()) {
      isValid = false;
      error.fName = "Please enter first name";
    }
    if (!lName.trim()) {
      isValid = false;
      error.lName = "Please enter last name";
    }
    if (!mobile.trim()) {
      isValid = false;
      error.mobile = "Please enter mobile number";
    } else if (!regPhone.test(mobile)) {
      isValid = false;
      error.mobile = "Invalid mobile number";
    }
    if (!bookingDate) {
      isValid = false;
      error.bookingDate = "Please select booking date";
    } else if (
      parseInt(validYear(bookingDate)) < 2016 ||
      parseInt(validYear(bookingDate)) > 2099
    ) {
      isValid = false;
      error.bookingDate = "Enter valid date";
    }
    if (!committedDate) {
      isValid = false;
      error.committedDate = "Please select committed date";
    } else if (
      parseInt(validYear(committedDate)) < 2016 ||
      parseInt(validYear(committedDate)) > 2099
    ) {
      isValid = false;
      error.committedDate = "Enter valid date";
    } else if (commitedDate < bookingdate) {
      isValid = false;
      error.committedDate = "Please enter valid date";
    }
    if (!exchange) {
      isValid = false;
      error.exchange = "Please select exchange";
    }
    if (!carModel) {
      isValid = false;
      error.carModel = "Please select car model";
    }
    if (!carVariant) {
      isValid = false;
      error.carVariant = "Please select car variant";
    }
    if (!carColour) {
      isValid = false;
      error.carColour = "Please select car color";
    }
    if (!yom) {
      isValid = false;
      error.yom = "Please enter YOM";
    } else if (!validYomValues.includes(yom)) {
      isValid = false;
      error.yom = "Please enter correct year of manufacturing";
    }

    setErrors(error);
    return isValid;
  };

  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    navigate("/login", { replace: true });
  };

  const FilterList = (model, setFilteredList) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      Model: model,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/common/GetFilterList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success" && result.status_code === 200) {
          setFilteredList(result.data);
          console.log("FilterList Data:", result.data);
        } else if (result.status_code === 400) {
          setErrorMessage("Something went wrong please contact support !");
        }
      })
      .catch((error) => {
        console.log("FilterList Error:", error);
        setErrorMessage("Something went wrong please contact support !");
      });
  };

  // Fetch initial models and variants/colors for carModel
  useEffect(() => {
    FilterList("", setFilteredList); // Fetch models
    if (carModel) {
      FilterList(carModel, setFilteredList); // Fetch variants and colors for pre-filled carModel
    }
  }, [carModel]);

  // Update carVariant and carColour when filteredList changes
  useEffect(() => {
    setCarVariant(
      filteredList.Variant?.some(
        (vrnt) => vrnt.toLowerCase() === carDetail.car_variant?.toLowerCase()
      )
        ? carDetail.car_variant
        : ""
    );
    setCarColour(
      filteredList.Colour?.some(
        (clr) => clr.toLowerCase() === carDetail.car_colour?.toLowerCase()
      )
        ? carDetail.car_colour
        : ""
    );
  }, [filteredList, carDetail.car_variant, carDetail.car_colour]);

  const formSubmitHandler = () => {
    if (validation()) {
      setLoading(true);
      var myHeaders = new Headers();
      myHeaders.append("Authorization", global.authToken);

      var formdata = new FormData();
      formdata.append("UserToken", UserToken);
      formdata.append("BookingID", carDetail.BookingID);
      formdata.append("customer_name", fName);
      formdata.append("LastName ", lName);
      formdata.append("customer_mobile ", mobile);
      formdata.append(
        "car_model  ",
        carModel || wingsData.model_name || carDetail.car_model
      );
      formdata.append(
        "car_variant ",
        carVariant || wingsData.variant || carDetail.car_variant
      );
      formdata.append(
        "car_colour ",
        carColour || wingsData.colour || carDetail.car_colour
      );
      formdata.append("BookingAmount", 0);
      formdata.append("yom ", yom);
      formdata.append("DateOfBooking", bookingDate);
      formdata.append("CommittedDeliveryDate", committedDate);
      formdata.append("receipt_num ", "N/A");
      formdata.append("win_num  ", wingsData.win_num || carDetail.win_num);
      formdata.append("Exchange", exchange);
      formdata.append("ASM", "");
      formdata.append("Executive", "");
      formdata.append("Remark ", remark);
      formdata.append("followup1 ", "");
      formdata.append("followup2 ", "");
      formdata.append("followup3 ", "");
      formdata.append("GetPassNumber  ", "N/A");
      formdata.append("WingsId   ", "");
      formdata.append("executive_id", "b6229344-f5d0-11ef-8b46-0211585a676a");
      formdata.append("salesman_id", "cbca0014-4730-4521-8c6b-25b396b23a0c");
      formdata.append("car_id    ", wingsData.CarStockID || carDetail.car_id);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${global.apiBaseUrl}/api/v1/stockone/am/AMInterDealerBookingUpdate`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status_code === 200 && result.status === "Success") {
            setMessage("Booking Updated Successfully");
            setWingsLoading(false);
            setFname("");
            setLname("");
            setMobile("");
            setWings("");
            setBookingDate("");
            setCommittedDate("");
            setExchange("");
            setRemark("");
            setCarModel("");
            setCarVariant("");
            setCarColour("");
            setYom("");
          } else if (result.status_code === 400) {
            setErrorMessage("Something went wrong please contact support !");
          }
        })
        .catch((error) => {
          console.log("error", error);
          setErrorMessage("Something went wrong please contact support !");
        })
        .finally(() => setLoading(false));
    }
  };

  const successMessage = () => {
    setTimeout(() => {
      setMessage("");
      // navigate("/stm-dashboard");
    }, 2000);
    return message;
  };

  const BreadCrumb = {
    pagename: "InterDealer",
    pagePath: "/stm-dashboard",
  };

  return (
    <>
      <Navbar navbarType={"black navbar"} />
      {message && <SuccessMessage message={successMessage()} />}
      {errorMessage && <ErrorMessage message={errorMessage} />}
      <Heading
        headingType={"Page Headings small"}
        BreadCrumHomeLink={"/stm-dashboard"}
        headingText={"InterDealer"}
        BreadCrumb={BreadCrumb}
        subheadingText={localStorage.getItem("Location")}
      />

      <div className={classes.mainContainer}>
        <div className={classes.searchContainer}>
          <div className={classes.headingFormContainer}>
            <Heading
              headingType={"sub heading small"}
              headingText={"Customer Details"}
            />

            <div className={classes.inputRow}>
              <div className={fName}>
                <Input
                  type={"input with label low height"}
                  inputType={"text"}
                  label={"First Name *"}
                  onChange={(e) => {
                    setFname(e.target.value);
                    errors.fName = "";
                  }}
                  value={fName}
                  error={errors.fName}
                />
                <span className={classes.error}>{errors.fName}</span>
              </div>
              <div className={lName}>
                <Input
                  type={"input with label low height"}
                  inputType={"text"}
                  label={"Last Name *"}
                  onChange={(e) => {
                    setLname(e.target.value);
                    errors.lName = "";
                  }}
                  value={lName}
                  error={errors.lName}
                />
                <span className={classes.error}>{errors.lName}</span>
              </div>
              <div className={mobile}>
                <Input
                  type={"input with label low height"}
                  inputType={"text"}
                  maxLength={10}
                  label={"Mobile Number *"}
                  onChange={(e) => {
                    onlyNumeric(e, setMobile);
                    errors.mobile = "";
                  }}
                  value={mobile}
                  error={errors.mobile}
                />
                <span className={classes.error}>{errors.mobile}</span>
              </div>
              <div className={bookingDate && classes.inputDisable}>
                <Input
                  type={"input with label low height"}
                  disabled={bookingDate}
                  inputType={"date"}
                  label={"Date of Booking *"}
                  onChange={(e) => {
                    setBookingDate(e.target.value);
                    errors.bookingDate = "";
                  }}
                  value={bookingDate}
                  error={errors.bookingDate}
                  onKeyDown={(e) => e.preventDefault()}
                />
                <span className={classes.error}>{errors.bookingDate}</span>
              </div>
              <div>
                <Input
                  type={"input with label low height"}
                  inputType={"date"}
                  label={"Committed Delivery Date*"}
                  onChange={(e) => {
                    setCommittedDate(e.target.value);
                    errors.committedDate = "";
                  }}
                  value={committedDate}
                  error={errors.committedDate}
                  onKeyDown={(e) => e.preventDefault()}
                />
                <span className={classes.error}>{errors.committedDate}</span>
              </div>
            </div>
          </div>

          <div>
            <Heading
              headingType={"sub heading small"}
              headingText={"Car Details"}
            />
            <div className={classes.inputRow}>
              <div>
                <Input
                  type={"Select Menus Simple native low height"}
                  label={"Model *"}
                  dropdownType={"Model"}
                  filteredData={filteredList}
                  selected={carModel === ""}
                  onChange={(e) => {
                    setCarModel(e.target.value);
                    setCarVariant("");
                    setCarColour("");
                    errors.carModel = "";
                  }}
                  value={carModel}
                  error={errors.carModel}
                />
                <span className={classes.error}>{errors.carModel}</span>
              </div>
              <div>
                <Input
                  type={"Select Menus Simple native low height"}
                  label={"Variant *"}
                  dropdownType={"Variant"}
                  filteredData={filteredList}
                  selected={carVariant === ""}
                  onChange={(e) => {
                    setCarVariant(e.target.value);
                    setCarColour("");
                    errors.carVariant = "";
                  }}
                  value={carVariant}
                  error={errors.carVariant}
                />
                <span className={classes.error}>{errors.carVariant}</span>
              </div>
              <div>
                <Input
                  type={"Select Menus Simple native low height"}
                  label={"Color *"}
                  dropdownType={"Color"}
                  filteredData={filteredList}
                  selected={carColour === ""}
                  onChange={(e) => {
                    setCarColour(e.target.value);
                    errors.carColour = "";
                  }}
                  value={carColour}
                  error={errors.carColour}
                />
                <span className={classes.error}>{errors.carColour}</span>
              </div>
              <div>
                <label
                  className="text-sm font-medium text-gray-700"
                  htmlFor="yomDropdown"
                >
                  YOM *
                </label>
                <br />
                <select
                  className={`mt-1 block w-full border outline-none text-sm rounded-md border-gray-300 px-2 py-1 ${errors.yom
                    ? "border-red-500 focus:ring-orange-500 bg-white"
                    : "focus:border-indigo-500 focus:ring-indigo-500 bg-white"
                    }`}
                  id="yomDropdown"
                  value={yom}
                  onChange={(e) => {
                    setYom(e.target.value);
                    errors.yom = "";
                  }}
                >
                  <option value="" disabled>
                    Select Year
                  </option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
                <br />
                <span className={classes.error}>{errors.yom}</span>
              </div>
            </div>
          </div>

          <div>
            <Heading
              headingType={"sub heading small"}
              headingText={"Other Details"}
            />
            <div className={classes.inputRow}>
              <div className={classes.radiobuttonWrapper}>
                <div>
                  <Input
                    type={"radio group"}
                    label="Exchange *"
                    value={exchange}
                    setState={setExchange}
                    data={notificationMethods}
                    onChange={() => (errors.exchange = "")}
                  />
                  <span className={classes.error}>{errors.exchange}</span>
                </div>
              </div>
              <div>
                <Input
                  type={"input with label low height"}
                  inputType={"text"}
                  label={"Remark"}
                  onChange={(e) => {
                    setRemark(e.target.value);
                  }}
                  value={remark}
                />
              </div>
            </div>
            <div className={classes.submitButtonWrapper}>
              <Button
                type={"whiteButton"}
                buttonText={"Cancel"}
                onClick={() => navigate("/stm-dashboard")}
              />
              <div className={classes.submitButton}>
                <Button
                  type={"smallButton"}
                  buttonText={"Save"}
                  onClick={() => {
                    formSubmitHandler();
                  }}
                  loading={loading}
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StmInterdealerUpdateBooking;
